import React from "react";
import useConfirm from "./useConfirm";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCore } from "../enums/queryFunction/Delete";
import { useTranslation } from "react-i18next";
import { SnackbarContext } from "../contexts/Snackbar";
import { useNavigate } from "react-router-dom";

export default function useDelete(
  id,
  url,
  key,
  confirmationMessage,
  navigateTo = -1,
  invalidateQueries = []
) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const { t } = useTranslation();
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("AreYouSure"),
    t("Accept"),
    t("Cancel"),
    "warning"
  );

  const { handleSnackbar } = React.useContext(SnackbarContext);

  function removeFromQuery(key, id) {
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData;
      const updatedData = oldData.filter(
        (item) => Number(item.id) !== Number(id)
      );
      return updatedData;
    });
  }

  async function deleteFn() {
    getMessage(t(confirmationMessage));
    const ans = await confirm();
    if (ans) {
      setLoading(true);
      mutation.mutate();
    }
  }

  const mutation = useMutation({
    mutationFn: () => deleteCore(url, id),
    retry: false,
    onSuccess: () => {
      if (Array.isArray(key)) {
        key.forEach((item) => removeFromQuery(item, id));
      } else {
        removeFromQuery(key, id);
      }
      const queriesToInvalidate = Array.isArray(invalidateQueries)
        ? invalidateQueries
        : invalidateQueries ? [invalidateQueries] : [];
      queriesToInvalidate.forEach((query) =>
        queryClient.invalidateQueries({ queryKey: Array.isArray(query) ? query : [query] })
      );
      setLoading(false);
      handleSnackbar("successMessage", "success");
      if (navigateTo) {
        navigate(navigateTo);
      }
    },
    onError: (error) => {
      setLoading(false);
      handleSnackbar("errorMessage", "error");
    },
  });
  return {
    deleteFn,
    ConfirmationDialog,
    loading,
  };
}
